import React from 'react';
import Navbar from './Navbar';
import CollegesSection  from "../CollegesSection"

const Layout = ({ children }) => {
  return (
    <>
      <Navbar />
      <main className="container py-4">
        {children}
      </main>
    </>
  );
};

export default Layout;
